import React from 'react';
import type { RouteObject } from 'react-router';
import { Outlet } from 'react-router-dom';
import AggregatorLayout from 'src/layouts/aggregator/aggregator-layout';
import { AggregatorRoutes } from 'src/enums/routes.enums';
import AggregatorDisclosures from 'src/pages/aggregator/aggregator-disclosures';
import AggregatorResponse from 'src/pages/aggregator/aggregator-response';
import AggregatorMerchantOffers from 'src/pages/aggregator/aggregator-merchant-offers';

const aggregatorRoutes: RouteObject[] = [
  {
    path: '/aggregator',
    element: (
      <AggregatorLayout>
        <Outlet />
      </AggregatorLayout>
    ),
    children: [
      {
        path: AggregatorRoutes.Disclosures,
        element: <AggregatorDisclosures />,
      },
      {
        path: AggregatorRoutes.Response,
        element: <AggregatorResponse />,
      },
      {
        path: AggregatorRoutes.MerchantOffers,
        element: <AggregatorMerchantOffers />,
      },
    ],
  },
];

export default aggregatorRoutes;
